<template>
  <div :class="$style.errorPage">
    <div :class="$style.errorContent">
      <h1 :class="$style.errorTitle">Something went wrong</h1>
      <p :class="$style.errorMessage">{{ error?.message || 'An unexpected error occurred.' }}</p>
      <p v-if="error?.statusCode" :class="$style.errorCode">Error {{ error.statusCode }}</p>
      <div :class="$style.errorActions">
        <button :class="$style.homeButton" @click="handleError">Go to Home</button>
        <button :class="$style.backButton" @click="goBack">Go Back</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

const props = defineProps({
  error: Object as () => { statusCode?: number; message?: string } | null,
})

onMounted(() => {
  const { $posthog } = useNuxtApp()
  $posthog?.()?.capture('error_page_shown', {
    status_code: props.error?.statusCode,
  })
})

const handleError = () => clearError({ redirect: '/' })
const goBack = () => {
  clearError()
  if (window.history.length > 1) {
    window.history.back()
  } else {
    navigateTo('/')
  }
}
</script>

<style module>
.errorPage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  min-height: 100vh;
  font-family: Inter, system-ui, sans-serif;
  background: #f9fafb;
}

.errorContent {
  text-align: center;
  max-width: 480px;
  padding: 40px 24px;
}

.errorTitle {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 12px;
}

.errorMessage {
  font-size: 16px;
  color: #6b7280;
  margin: 0 0 8px;
  line-height: 1.5;
}

.errorCode {
  font-size: 14px;
  color: #9ca3af;
  margin: 0 0 32px;
}

.errorActions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.homeButton {
  padding: 10px 24px;
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.homeButton:hover {
  background: #374151;
}

.backButton {
  padding: 10px 24px;
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.backButton:hover {
  background: #f9fafb;
}
</style>
